/**
 * Marketing components module
 *
 * Reusable components for marketing pages and sections.
 *
 * @module marketing-components
 */

export { AnimatedBackground } from './animated-background';
export { ComparisonTable } from './comparison-table';
export { FAQSection } from './faq-section';
export { FAQAccordion } from './faq-accordion';
export { FeatureCard } from './feature-card';
export { HowToSteps } from './how-to-steps';
export { FeatureList } from './feature-list';
export { IconWrapper } from './icon-wrapper';
export { InternalLinksSection } from './internal-links-section';
export { KeyTakeaway } from './key-takeaway';
export { MarketingCTA } from './marketing-cta';
export { PageHeader } from './page-header';
export { PrivacyDataTable } from './privacy-data-table';
export { ScoringBreakdownCard } from './scoring-breakdown-card';
export { SectionCard } from './section-card';
export { SectionTracker } from './section-tracker';
export { TrackedLink } from './tracked-link';
export { TrustBadge } from './trust-badge';

export type { ComparisonRow, ComparisonTableProps } from './comparison-table';
export type { FeatureCardProps } from './feature-card';
export type { HowToStepsProps } from './how-to-steps';
export type { FeatureListProps } from './feature-list';
export type { IconWrapperProps } from './icon-wrapper';
export type { InternalLink, InternalLinksSectionProps } from './internal-links-section';
export type { MarketingCTAProps } from './marketing-cta';
export type { PrivacyDataRow, PrivacyDataTableProps } from './privacy-data-table';
export type { ScoringBreakdownCardProps } from './scoring-breakdown-card';
export type { SectionCardProps } from './section-card';
